import { useEffect, useState } from "react";
import { _axios } from "../utils/axios";

export type TMoujaConfig = {
  mouja_name: string;
  khasra_start: number;
  khasra_end: number;
  [key: string]: any;
};

export function useMoujaConfigs() {
  const [moujaConfigs, setMoujaConfigs] = useState<TMoujaConfig[]>([]);

  useEffect(() => {
    _axios
      .get("/admin/mouja-asr-config")
      .then((res: any) => {
        if (res.data && res.data.data) {
          setMoujaConfigs(res.data.data);
        }
      })
      .catch((err: any) => console.error("Error fetching Mouja config:", err));
  }, []);

  return moujaConfigs;
}

export function getKhasaraRangeForMouja(
  moujaConfigs: TMoujaConfig[],
  selectedMauja: unknown
) {
  const maujaStr = String(selectedMauja ?? "").trim().toLowerCase();

  const matchedMoujaRow = moujaConfigs.find((m) => {
    const mName = String(m.mouja_name ?? "").trim().toLowerCase();
    return (
      mName === maujaStr ||
      (maujaStr.length > 2 && mName.includes(maujaStr)) ||
      (mName.length > 2 && maujaStr.includes(mName))
    );
  });

  const maxLimit = matchedMoujaRow?.khasra_end
    ? Number(matchedMoujaRow.khasra_end)
    : 134;
  const minLimit = matchedMoujaRow?.khasra_start
    ? Number(matchedMoujaRow.khasra_start)
    : 1;
  const maujaDisplayName =
    matchedMoujaRow?.mouja_name || (maujaStr ? maujaStr : "Bahadura");

  const khasaraOptions = Array.from(
    { length: Math.max(1, maxLimit - minLimit + 1) },
    (_, i) => minLimit + i
  );

  return { minLimit, maxLimit, maujaDisplayName, khasaraOptions };
}

/** Looks up asr_max_rate for the selected Mouja from cp_bahadura_khasra_master, via the same matching logic as getKhasaraRangeForMouja. Returns 0 if no match. */
export function getAsrMaxRateForMouja(
  moujaConfigs: TMoujaConfig[],
  selectedMauja: unknown
) {

  const maujaStr = String(selectedMauja ?? "").trim().toLowerCase();

  const matchedMoujaRow = moujaConfigs.find((m) => {
    const mName = String(m.mouja_name ?? "").trim().toLowerCase();
    return (
      mName === maujaStr ||
      (maujaStr.length > 2 && mName.includes(maujaStr)) ||
      (mName.length > 2 && maujaStr.includes(mName))
    );
  });

  return matchedMoujaRow?.asr_max_rate ? Number(matchedMoujaRow.asr_max_rate) : 0;
}

/** Splits a combined "main/manual" Khasara string, e.g. "77/55/65" -> { main: "77", manual: "55/65" } */
export function splitCombinedKhasaraNo(combined?: unknown) {
  const value = String(combined ?? "").trim();
  if (!value) return { main: "", manual: "" };
  const [main, ...rest] = value.split("/");
  return { main: main ?? "", manual: rest.join("/") };
}
